import { PropsWithChildren, ReactNode, useMemo } from 'react';
import { useCan } from '../hooks/use-can';
import { Permission } from '../types';

export interface PermissionBoundaryProps extends PropsWithChildren {
  permissionsRequired: Permission[] | Permission;
  placeholder?: ReactNode;
  operator?: 'AND' | 'OR';
}

export const PermissionBoundary = ({
  permissionsRequired,
  operator = 'AND',
  placeholder = null,
  children,
}: PermissionBoundaryProps) => {
  const can = useCan();
  const hasUserPermissions = useMemo(
    () =>
      can({
        permissions: permissionsRequired,
        operator,
      }),
    [can, operator, permissionsRequired]
  );

  return hasUserPermissions ? <>{children}</> : placeholder;
};
